module.exports = __webpack_public_path__ + "yeni fransa mutfak 5.jpg?657fa03d5f8038c3679e22b432966453";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/yeni fransa mutfak 5.jpg
// module id = 369
// module chunks = 0